export default __webpack_public_path__ + "static/media/May_20_2023.321da988.jpeg";